var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 51,
    viewBox: "0 0 54 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter0_d_3021_37084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9024 38.7633C26.4882 38.7517 27.0503 38.5612 27.4894 38.2256C27.9284 37.8901 28.2161 37.431 28.3015 36.9297H23.4103C23.4981 37.4446 23.7993 37.9145 24.2577 38.2518C24.7161 38.5891 25.3006 38.7709 25.9024 38.7633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7108 33.8206L39.3947 33.5793C38.4977 32.8881 37.7127 32.0955 37.0607 31.2229C36.3486 30.0186 35.9218 28.7034 35.8053 27.3545V23.3816C35.8015 22.899 35.7518 22.4175 35.6565 21.942C34.0814 21.662 32.6665 20.9199 31.6515 19.8412C30.6364 18.7625 30.0835 17.4136 30.0864 16.0229V15.5162C29.1156 15.103 28.0724 14.8313 26.9992 14.712V13.6987C26.9992 13.4139 26.8684 13.1408 26.6356 12.9395C26.4028 12.7381 26.087 12.625 25.7578 12.625C25.4285 12.625 25.1128 12.7381 24.88 12.9395C24.6472 13.1408 24.5164 13.4139 24.5164 13.6987V14.7522C22.1133 15.0454 19.9139 16.0806 18.3244 17.6667C16.7349 19.2528 15.8625 21.2827 15.8684 23.3816V27.3545C15.7519 28.7034 15.3251 30.0186 14.613 31.2229C13.9722 32.0933 13.1997 32.8858 12.3162 33.5793L12 33.8206V36.0885H39.7108V33.8206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0613 20.0423C39.6292 20.0423 41.7108 18.242 41.7108 16.0212C41.7108 13.8003 39.6292 12 37.0613 12C34.4935 12 32.4119 13.8003 32.4119 16.0212C32.4119 18.242 34.4935 20.0423 37.0613 20.0423Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3021_37084",
    x: 0,
    y: 0,
    width: 53.7108,
    height: 50.7617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3021_37084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3021_37084",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.326075ed34437b26fc9ff58e353c3d0d.svg";
export { ForwardRef as ReactComponent };